<template>
  <div :class="`col-xs-12 profile-card ${layoutStyle}`">
    <el-card :body-style="{ padding: '0px' }" shadow="hover">
      <div id="grid-image-container">
        <el-image
          class="grid-image"
          fit="'cover'"
          lazy
          @error="imageLoadError"
          :src="profile.image ? profile.image : identicon"
        >
          <div slot="placeholder" class="image-slot">
            <img width="120" height="120" :src="identicon" />
          </div>
        </el-image>
      </div>
      <div class="profile-card-content">
        <div class="top-content">
          <div class="profile-name" v-if="profile.name">
            <el-tooltip :content="profile.name" placement="bottom">
              <p>{{ profile.name }}</p>
            </el-tooltip>
          </div>
          <div class="profile-name" v-else>
            <el-tooltip :content="profile.identifier" placement="bottom">
              <p>{{ profile.identifier }}</p>
            </el-tooltip>
          </div>
          <div class="profile-identifier" v-if="profile.name">{{ profile.identifier }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import jdenticon from 'jdenticon';

export default {
  name: 'GridCard',

  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showFallbackProfileImage: false,
  }),

  computed: {
    layoutStyle() {
      const listViewSize = 12;
      return this.columnSize === listViewSize ? 'list-view ' : '';
    },
    identicon() {
      const identiconToBase64 = btoa(jdenticon.toSvg(this.profile.identifier, 128));
      return `data:image/svg+xml;base64,${identiconToBase64}`;
    },
  },

  methods: {
    imageLoadError() {
      this.profile.image = null;
    },
  },
};
</script>

<style lang="scss">
$profile-image-size: 120px;

.grid-image-container {
  width: $profile-image-size;
  background-color: #676a6c;
  height: 100%;
  float: left;
  margin: 0;
  padding: 0;
  border: none;
}

.grid-image {
  width: 120px;
  float: left;

  > img {
    width: $profile-image-size;
    height: $profile-image-size;
  }

  .image-slot {
    text-align: center;
    background: #eee;
    width: $profile-image-size;
    height: $profile-image-size;
  }
}

.profile-card-content {
  float: right;
  width: calc(100% - #{$profile-image-size});
  height: 100%;
  padding: 8px;
  display: block;
}

.profile-card {
  cursor: pointer;
  max-height: $profile-image-size;
  padding: 10px;
  margin-bottom: 10px;
}

.top-content {
  text-align: left;
  float: left;
  display: block;
  width: 100%;
}

.bottom-content {
  text-align: left;
  float: left;
  display: block;
  width: 100%;
}

.profile-name {
  color: #676a6c;
  font-size: 1.5em;
  font-weight: bold;
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;

  > p {
    font-size: 0.9em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.profile-identifier {
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-demographic {
  color: gray;
  margin-top: 13px;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-view {
  padding: 0px 20% 0px 20%;
}
</style>



// WEBPACK FOOTER //
// GridCard.vue?5f8dfee7